import { Link } from 'gatsby';
import { nightOwl } from '@code-surfer/themes';
import { themes, Appear, Head } from 'mdx-deck';
import { CodeSurfer, CodeSurferColumns, Step } from 'code-surfer';
import "..\\..\\..\\..\\slides\\styles\\overrides.css";
import "..\\..\\..\\..\\slides\\styles\\styles.css";
import MediaQuerySyntax from "..\\..\\..\\..\\slides\\images\\media-query-syntax.png";
import ComparisonMediaQueryVsContainerQuery from "..\\..\\..\\..\\slides\\images\\comparison-media-query-vs-container-query.jpg";
import * as React from 'react';
export default {
  Link,
  nightOwl,
  themes,
  Appear,
  Head,
  CodeSurfer,
  CodeSurferColumns,
  Step,
  MediaQuerySyntax,
  ComparisonMediaQueryVsContainerQuery,
  React
};